var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#222222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 3.26562H11.6445C11.7591 3.26562 11.8164 3.32292 11.8164 3.4375V18.5625C11.8164 18.6771 11.7591 18.7344 11.6445 18.7344H10.3555C10.2409 18.7344 10.1836 18.6771 10.1836 18.5625V3.4375C10.1836 3.32292 10.2409 3.26562 10.3555 3.26562Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 10.1836H18.2188C18.3333 10.1836 18.3906 10.2409 18.3906 10.3555V11.6445C18.3906 11.7591 18.3333 11.8164 18.2188 11.8164H3.78125C3.66667 11.8164 3.60938 11.7591 3.60938 11.6445V10.3555C3.60938 10.2409 3.66667 10.1836 3.78125 10.1836Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.91d57b06.svg";
export { ForwardRef as ReactComponent };